import { useState } from "react";
import { Box, Typography, Grid, Paper, Fab } from "@mui/material";
import { DEFAULT_COLOR, YELLOW_COLOR } from "@/constants/color";
import { ScrollText, FilterIcon, Bot } from "lucide-react";
import { FilterDrawer } from "@/components/forms/DateFilter";
import dayjs from "dayjs";
import downloadReport from "@/services/reporter/download";
import { BOT_URL } from "@/constants/bot";

export default function Dashboard() {
  const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);

  const [filters, setFilters] = useState({
    startDate: dayjs().subtract(1, "week").toDate(),
    endDate: dayjs().toDate(),
  });

  const handleResetFilters = () => {
    setFilters({
      startDate: dayjs().subtract(1, "week").toDate(),
      endDate: dayjs().toDate(),
    });
  };

  const toggleFilterDrawer = () => {
    setFilterDrawerVisible((p) => !p);
  };

  const handleFilterChange = (key: string, value: string | Date | null) => {
    setFilters({
      ...filters,
      [key]: value,
    });
  };

  const reports = [
    {
      key: "1",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      title: "Contactos",
      route: "leads",
    },
    {
      key: "2",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "leads-by-user",
      title: "Contactos por usuario",
    },
     {
      key: "10",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "lost-leads",
      title: "Contactos perdidos",
    },
    {
      key: "3",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "leads-by-status",
      title: "Contactos por estatus",
    },
    {
      key: "4",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "leads-detail",
      title: "Reporte detallado de contactos",
    },
    {
      key: "5",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "deals",
      title: "Tratos",
    },
    {
      key: "6",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "deals-by-user",
      title: "Tratos por usuario",
    },
    {
      key: "7",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "deals-by-status",
      title: "Tratos por estatus",
    },
    {
      key: "8",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "deals-detail",
      title: "Reporte detallado de tratos",
    },
    {
      key: "9",
      icon: <ScrollText size={80} style={{ color: DEFAULT_COLOR }} />,
      route: "detail",
      title: "Reporte General",
    },
  ];
  return (
    <Box>
      <Grid size={{ xs: 12 }}>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: "bold",
            color: DEFAULT_COLOR,
            mt: 2,
            display: { xs: "none", sm: "block" },
          }}
        >
          Reportes
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        {reports.map((report) => {
          return (
            <Grid size={{ xs: 12, md: 4 }} key={report.key}>
              <Paper
                elevation={3}
                sx={{
                  minHeight: 200,
                  p: 2,
                  textAlign: "center",
                  justifyContent: "center",
                  alignContent: "center",
                  cursor: "pointer",
                }}
                onClick={() =>
                  downloadReport({
                    path: report.route,
                    name: report.title,
                    startDate: filters.startDate,
                    endDate: filters.endDate,
                  })
                }
              >
                {report.icon}
                <Typography color={DEFAULT_COLOR}>{report.title}</Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
      <Fab
        aria-label="add"
        sx={{
          backgroundColor: YELLOW_COLOR,
          color: "white",
          position: "fixed",
          bottom: { xs: 150, sm: 150 },
          right: 16,
          zIndex: 3000,
          "&:hover": {
            backgroundColor: YELLOW_COLOR,
          },
          display: filterDrawerVisible ? "none" : "",
        }}
        onClick={toggleFilterDrawer}
      >
        <FilterIcon />
      </Fab>
      <Fab
        aria-label="bot"
        sx={{
          backgroundColor: DEFAULT_COLOR,
          color: "white",
          position: "fixed",
          bottom: { xs: 80, sm: 80 },
          right: 16,
          zIndex: 3000,
          display: filterDrawerVisible ? "none" : "",
          "&:hover": {
            backgroundColor: DEFAULT_COLOR,
          },
        }}
        onClick={() => window.open(BOT_URL, "_blank")}
      >
        <Bot />
      </Fab>
      <FilterDrawer
        open={filterDrawerVisible}
        onClose={toggleFilterDrawer}
        filterChange={handleFilterChange}
        filters={filters}
        handleResetFilters={handleResetFilters}
      />
    </Box>
  );
}
